import React from 'react';

import styles from './styles.module.scss';

const StepCounter = ({ percentage, step, steps }) => {
  const dashArray = 20 * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  return (
    <div className={styles.step_counter}>
      <svg width={50} height={50} viewBox={`0 0 50 50`}>
        <circle
          cx={25}
          cy={25}
          strokeWidth='5px'
          r={20}
          className={styles.circle_background}
        />

        <circle
          cx={25}
          cy={25}
          strokeWidth='5px'
          r={20}
          className={styles.circle_progress}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
          transform='rotate(-90 25 25)'
        />

        <text
          x='50%'
          y='50%'
          dy='0.3em'
          textAnchor='middle'
          className={styles.circle_text}
        >
          {step}
          <tspan className={styles.circle_inner_text}>/{steps}</tspan>
        </text>
      </svg>
    </div>
  );
};

export default StepCounter;
